import React, {createContext, useReducer} from 'react'
import {ReceiverFilterReducer} from "../reducers/ReceiveFilterReducer";

export const ReceiveFilterContext = createContext();

const ReceiveFilterContextProvider = (props) => {
    const [ filter, dispatch] = useReducer(ReceiverFilterReducer,{selectedCycles:[], allCycles:[], selectedCPT:[], allCPT:[], CPTLabel:'', filterIdentifier:'CPT'});
    return (
        <ReceiveFilterContext.Provider value = {{filter, dispatch}}>
            {props.children}
        </ReceiveFilterContext.Provider>
    )
}

export default ReceiveFilterContextProvider


// WEBPACK FOOTER //
// ./src/components/receive/context/ReceiveFilterContext.js